import React, { Component, PropTypes } from 'react'
import classNames from 'classnames'
import PaintFillChooser from 'components/PaintFillChooser'

class LineChooser extends Component {
  render() {
    const { name, options, selected, paints, isError, isPaintError, onFieldChange, onSelectPaintFill } = this.props;
    const radioGroup = this.props.radioGroup || name
    return (
      <span className={classNames(['line-chooser', name])}>
        {(options || []).map(o => {
          const isSelected = selected && (o.id === selected.id);

          return <div key={o.id} className="side-radio">
            <label className={classNames({ "error" : isError }) + (!!isSelected ? ' option-selected' : '')}>
              <div className={(!!isSelected ? ' option-selected' : '') + " radio-target"} ></div>
              <input type="radio" name={radioGroup}
                value={o.id}
                onChange={(evt) => { onFieldChange(evt.target.value); }}
                checked={!!isSelected}
              />
              {o.label}
            </label>
            <div className="customize-form-section-content">
              {isSelected && paints.length > 0 &&
                <div>
                  <div className="include-paintfill">Includes Paintfill</div>
                  {paints.map(paint =>
                    <PaintFillChooser 
                      key={paint.loc.id}
                      loc={paint.loc}
                      paints={paint.paints}
                      selectedPaint={paint.selected}
                      isError={isPaintError && !paint.valid}
                      onSelectPaintFill={(p) => onSelectPaintFill(paint.loc.id, p.id)}
                      labelOverride={(name === 'sightDot') ? 'Dot' : null}
                      isOpen={true}
                    />
                  )}
                </div>
              }
            </div>
          </div>

        })}
      </span>
    )
  }
}

LineChooser.propTypes = {
  name: PropTypes.string.isRequired,
  radioGroup: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
  })),
  selected: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }),
  paints: PropTypes.arrayOf(PropTypes.shape({
    loc: PropTypes.object,
    paints: PropTypes.arrayOf(PropTypes.object),
    selected: PropTypes.object,
  })),
  isError: PropTypes.bool,
  isPaintError: PropTypes.bool,
  onFieldChange: PropTypes.func.isRequired,
  onSelectPaintFill: PropTypes.func, 
}

export default LineChooser